import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import Smartphone from 'components/Icons/Smartphone'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'

const t = buildTranslate('live_updates.preview')

const ICON_SIZE = 16

// Both the lock-screen Live Activity and in-app tracker require a minimum
// guest app version to render at all — a permanent client capability, not a
// merchant-configurable or rollout-flagged state, so this renders
// unconditionally alongside the preview rather than behind a prop (Figma
// 2844:28382). BodyText5 (12px), not BodyText4 (14px, the literal Figma
// spec): the preview column is narrower than Figma's mockup frame, so the
// literal size wraps the sentence, sized down here to keep it on one line.
const AppVersionNotice = () => {
  const [css] = useStyletron()

  return (
    <div
      data-testid="lu-preview-app-version-notice"
      className={css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '4px',
        whiteSpace: 'nowrap',
      })}
    >
      {/* Smartphone already sets aria-hidden on its own <svg> — no wrapper
          span needed. */}
      <Smartphone fillColor={palette.grey90} size={ICON_SIZE} />
      <Text.BodyText5 color="grey90">{t('app_version_notice')}</Text.BodyText5>
    </div>
  )
}

export default AppVersionNotice
